import { sectionColors } from '../consts';
import { Color } from '../types';

export default function getNextSectionColor(index: number): Color {
    return sectionColors[index % sectionColors.length];
}